import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ShiftResource, shiftsCommitShift } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCommitShift = (
  options: UseMutationOptions<ShiftResource, unknown, { id: number }, unknown>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) =>
      extractData(
        shiftsCommitShift({
          path: { id },
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['shifts', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
